import styles from "./HintButton.module.css";

export interface HintButtonProps {
  /** Once a hint has been revealed for this place, re-opening it is free. */
  revealed: boolean;
  onClick: () => void;
  getHintLabel: string;
  viewHintLabel: string;
}

/**
 * Small icon button shown next to a place while a round is still active —
 * opens a map overlay revealing where that place actually is, at a point
 * cost (see HintMapOverlay / each round's scoring). Stops pointer
 * propagation so it never gets mistaken for a drag start on cards that are
 * themselves draggable (LineUp/Beeline's sort rounds).
 */
export function HintButton({ revealed, onClick, getHintLabel, viewHintLabel }: HintButtonProps) {
  return (
    <button
      type="button"
      className={`${styles.button} ${revealed ? styles.revealed : ""}`}
      aria-label={revealed ? viewHintLabel : getHintLabel}
      onPointerDown={(e) => e.stopPropagation()}
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
    >
      <svg viewBox="0 0 20 20" width="16" height="16" aria-hidden focusable="false">
        <path
          d="M10 2.5a5.5 5.5 0 0 0-3.2 9.98c.45.33.7.85.7 1.4V14h5v-.12c0-.55.25-1.07.7-1.4A5.5 5.5 0 0 0 10 2.5Z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <path d="M8.3 16.5h3.4M8.7 18h2.6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    </button>
  );
}
